var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',[_c('fm-title',{attrs:{"title-text":"工作信息"}}),_c('data-form',{attrs:{"source-data":_vm.dealSourceData,"edit-data":_vm.formData,"form-parms":_vm.formParms,"wait-data":_vm.waitData,"is-absolut":_vm.isAbsolut,"wait-keys":_vm.waitKeys},on:{"formChange":_vm.formChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }